export default "/fonts/vendor/katex/dist/KaTeX_AMS-Regular.woff?d562e886c52f12660a41eea8d05af757";